var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37986 6.56667C3.8932 5.64 4.87986 5.09333 5.4532 4.27333C6.05986 3.41333 5.71986 1.80667 3.99986 1.80667C2.8732 1.80667 2.31986 2.66 2.08653 3.36667L0.359863 2.64C0.833197 1.22 2.11986 0 3.9932 0C5.55986 0 6.6332 0.713333 7.17986 1.60667C7.64653 2.37333 7.91986 3.80667 7.19986 4.87333C6.39986 6.05333 5.6332 6.41333 5.21986 7.17333C5.0532 7.48 4.98653 7.68 4.98653 8.66667H3.05986C3.0532 8.14667 2.9732 7.3 3.37986 6.56667ZM5.3332 11.3333C5.3332 12.0667 4.7332 12.6667 3.99986 12.6667C3.26653 12.6667 2.66653 12.0667 2.66653 11.3333C2.66653 10.6 3.26653 10 3.99986 10C4.7332 10 5.3332 10.6 5.3332 11.3333Z",
    fill: "#AEAEAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/HelpIcon.9fb8bcf33b270df870185f109013d877.svg";
export { ForwardRef as ReactComponent };